// extracted by mini-css-extract-plugin
module.exports = {"search":"YC7Ce","sticky":"_1Ybld","iconSearch":"_1lcN2","buttonClear":"_2WlpS","label":"_1noIp","iconClear":"_1xCLu","input":"_3V0kq"};